import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgEyeText = (props, ref) => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 32 32", role: "img", ref, ...props, children: /* @__PURE__ */ jsx("g", { id: "a3ba47c0-a3fc-4226-93d5-361cbc1e7fb6", children: /* @__PURE__ */ jsxs("g", { id: "b5ebd7c7-1fb9-4e66-b0c2-c773d03e089b", children: [
  /* @__PURE__ */ jsxs("g", { children: [
    /* @__PURE__ */ jsx("path", { d: "M5,16S9,8,16,8s11,8,11,8-4,8-11,8S5,16,5,16Z", style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    } }),
    /* @__PURE__ */ jsx("circle", { cx: 16, cy: 16, r: 3, style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    } })
  ] }),
  /* @__PURE__ */ jsx("rect", { width: 32, height: 32, style: {
    fill: "none"
  } }),
  /* @__PURE__ */ jsx("rect", { x: 20, y: 15, width: 11, height: 11, style: {
    fill: "#fff"
  } }),
  /* @__PURE__ */ jsxs("g", { children: [
    /* @__PURE__ */ jsxs("g", { children: [
      /* @__PURE__ */ jsx("polyline", { points: "22.38 19.27 22.38 17.72 30.66 17.72 30.66 19.27", style: {
        fill: "none",
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2
      } }),
      /* @__PURE__ */ jsx("polyline", { points: "22.38 19.27 22.38 17.72 30.66 17.72 30.66 19.27", style: {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2
      } })
    ] }),
    /* @__PURE__ */ jsx("line", { x1: 24.97, y1: 26, x2: 28.07, y2: 26, style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    } }),
    /* @__PURE__ */ jsxs("g", { children: [
      /* @__PURE__ */ jsx("line", { x1: 26.52, y1: 17.72, x2: 26.52, y2: 26, style: {
        fill: "none",
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2
      } }),
      /* @__PURE__ */ jsx("line", { x1: 26.52, y1: 17.72, x2: 26.52, y2: 26, style: {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2
      } })
    ] })
  ] })
] }) }) });
const ForwardRef = forwardRef(SvgEyeText);
export default ForwardRef;
